<template>
  <div>
    <nav class="nav-extended primary-bg">
      <a href="#" data-target="mobile-menu" class="sidenav-trigger">
        <i class="material-icons">menu</i>
      </a>

      <div class="container">
        <div class="nav-wrapper">
          <router-link v-if="!userSignedIn" class="brand-logo" to="/"
            >LockerApp</router-link
          >
          <router-link v-if="userSignedIn" class="brand-logo" to="/passwords"
            >LockerApp</router-link
          >

          <ul id="nav-mobile" class="right hide-on-med-and-down">
            <li v-if="!userSignedIn">
              <router-link to="/about">About</router-link>
            </li>
            <li v-if="userSignedIn">
              <router-link to="/passwords">Passwords</router-link>
            </li>
            <li v-if="userSignedIn">
              <router-link to="/notes">Notes</router-link>
            </li>
            <li>
              <router-link to="/passwordgenerator"
                >Password Generator</router-link
              >
            </li>

            <li v-if="!userSignedIn">
              <router-link to="/signup">Sign up</router-link>
            </li>
            <li v-if="!userSignedIn">
              <router-link to="/">Sign in</router-link>
            </li>
            <li v-if="userSignedIn">
              <router-link to="/settings">Settings</router-link>
            </li>
            <li v-if="userSignedIn">
              <a v-on:click="logOut" class="error-fg">Log out</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <ul class="sidenav" id="mobile-menu">
      <li v-if="!userSignedIn">
        <router-link to="/about">About</router-link>
      </li>
      <li v-if="userSignedIn">
        <router-link to="/passwords">Passwords</router-link>
      </li>
      <li v-if="userSignedIn">
        <router-link to="/notes">Notes</router-link>
      </li>
      <li>
        <router-link to="/passwordgenerator">Password Generator</router-link>
      </li>
      <li v-if="!userSignedIn">
        <router-link to="/signup">Sign up</router-link>
      </li>
      <li v-if="!userSignedIn">
        <router-link to="/">Sign in</router-link>
      </li>
      <li v-if="userSignedIn">
        <router-link to="/settings">Settings</router-link>
      </li>
      <li v-if="userSignedIn">
        <a v-on:click="logOut" class="error-fg">Log out</a>
      </li>
    </ul>
  </div>
</template>

<script>
import M from "materialize-css";
import firebase from "firebase/app";
import "firebase/auth";

export default {
  name: "NavBar",
  props: {
    userSignedIn: Boolean
  },
  methods: {
    logOut: function() {
      let vueInstance = this;
      firebase
        .auth()
        .signOut()
        .then(
          function() {
            // Sign-out successful.
            //Navigate to the login html
            vueInstance.clearHops();
            vueInstance.$router.push("/");
          },
          function(error) {
            // An error happened.
            alert(error.errorMessage);
          }
        );
    }
  },
  mounted() {
    M.AutoInit();
    document.addEventListener("DOMContentLoaded", function() {
      var elems = document.querySelectorAll(".sidenav");
      M.Sidenav.init(elems, {});
    });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.navBarLogo {
  margin-left: 10px;
  margin-right: 10px;
  width: 45px;
  height: 45px;
  border: 1px solid white;
  border-radius: 100%;
  float: left;
  margin-top: 8px;
}
</style>
